export type ZodiacResult = {
  text: string;
  color: string;
};

export const getZodiacResult = (value: number): ZodiacResult => {
  if (value >= 0 && value <= 20)
    return {
      text: 'Звёзды говорят, что будет сложно найти общий язык. Но иногда именно такие вызовы делают отношения интереснее — попробуйте',
      color: '#F53C14',
    };

  if (value >= 21 && value <= 40)
    return {
      text: 'Ваши знаки не идеально сочетаются, и различий может быть много. Однако противоположности часто притягиваются сильнее всего',
      color: '#F3660C',
    };

  if (value >= 41 && value <= 60)
    return {
      text: 'Ваши знаки в меру совместимы, что даёт простор для развития отношений. Тут всё будет зависеть от того, насколько вам интересно друг с другом',
      color: '#FFA800',
    };

  if (value >= 61 && value <= 75)
    return {
      text: 'Хорошие новости: ваши знаки довольно неплохо сочетаются! У вас есть хороший потенциал для комфортного и приятного общения',
      color: '#B7A914',
    };

  if (value >= 76 && value <= 90)
    return {
      text: 'Звёзды явно за вас: вы прекрасно дополняете друг друга! Шансы на яркие эмоции и искреннюю симпатию очень высоки',
      color: '#68B52E',
    };

  if (value >= 91 && value <= 100)
    return {
      text: 'Это идеальная совместимость — ваши знаки буквально созданы друг для друга! Возможно, именно здесь ждёт что‑то по‑настоящему особенное',
      color: '#00C451',
    };

  return { text: '', color: 'inherit' };
};
